module.exports = __webpack_public_path__ + "img/1F609.03c8bcea.svg";